import { render, staticRenderFns } from "./StepToValidate.vue?vue&type=template&id=87cc03cc&scoped=true"
import script from "./StepToValidate.vue?vue&type=script&lang=js"
export * from "./StepToValidate.vue?vue&type=script&lang=js"
import style0 from "./StepToValidate.vue?vue&type=style&index=0&id=87cc03cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cc03cc",
  null
  
)

export default component.exports